export default (inString) =>
  inString.substring(0, 1).toUpperCase() + inString.slice(1);
